import { InjectionToken } from '@angular/core';
import { Environment } from '../types/enviroment.types';

export const ENVIRONMENT = new InjectionToken<Environment>('app.environment.token');
